<template>
  <v-card class="pa-4">
    <h3 class="text-center"><strong>Lixeira</strong></h3>

    <div class="text-center d-flex justify-center">
      <div style="max-width: 500px">
        As pastas e arquivos listados abaixo serão excluídos permanentemente
        após o passar de 30 dias da data de envio para a lixeira!
      </div>
    </div>

    <v-divider class="ma-4"></v-divider>

    <div class="d-flex justify-space-between flex-wrap">
      <v-row dense class="ma-0" align="center" style>
        <v-col cols="12" sm="5" style="min-width: 222px">
          <label class="label">Nome</label>
          <v-text-field
            v-model="filterListFolderWithDoc.name"
            class="primary-input"
            outlined
            hide-details="auto"
            placeholder="Pesquisar por Nome"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="2" style="margin-top: auto">
          <v-btn class="primary-button ma-1 mb-4" depressed @click="loadData">
            Filtrar
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <v-data-table
      :loading="loading"
      :loading-text="$t('Carregando...')"
      :no-data-text="$t('Nenhuma arquivo encontrado')"
      :headers="headers"
      :items="listFolderWithDoc"
      class="main-table"
      hide-default-footer
      :items-per-page="pageSize"
      :header-props="headerProps"
    >
      <template #[`item.isDocument`]="{ item }">
        <span
          v-if="item.isDocument"
          style="margin-bottom: -4px; margin-left: 6px"
        >
          <v-icon class="pr-2" style="margin-top: -3px">
            mdi-file-document-outline
          </v-icon>
        </span>
        <span v-else>
          <v-icon class="pr-2" style="margin-top: -3px">
            mdi-folder-outline
          </v-icon>
        </span>
      </template>

      <template #[`item.deleteAt`]="{ item }">
        {{ formatDate(item.deleteAt) }}
      </template>

      <template #[`item.actions`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              x-small
              color="primary"
              tile
              fab
              depressed
              style="border-radius: 6px"
              @click="recover(item)"
            >
              <v-icon>mdi-backup-restore</v-icon>
            </v-btn>
          </template>
          <span>Restaurar arquivo</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              x-small
              color="error"
              tile
              fab
              depressed
              style="border-radius: 6px; margin-left: 8px"
              @click="deleteItem(item)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>Excluir arquivo</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <div class="pagination">
      <div class="item-pagination block-one">
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="btn"
              depressed
              color="#C0C0C0"
              small
            >
              qtd: {{ pageSize }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(size, i) in sizes"
              :key="i"
              @click="pageSize = size"
            >
              <v-list-item-title>{{ size }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <div class="registros" v-if="totalItensOnPage">
          <span> 1 - {{ totalItensOnPage }} de {{ totalItems }} </span> <br />
        </div>
      </div>

      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="page"
          :length="totalPages"
          :total-visible="3"
        ></v-pagination>
      </div>
    </div>
    <v-dialog v-model="deleteDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            Tem certeza de que deseja enviar esta pasta para a lixeira?
          </div>

          <v-btn class="ma-1" color="grey" text @click="deleteDialog = false">
            Cancelar
          </v-btn>
          <v-btn
            class="ma-1"
            color="error"
            text
            @click="confirmDelete(itemToDelete)"
          >
            Excluir
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>
  </v-card>
</template>

<script>
import moment from 'moment'
import ApiService from '../../../../../services/ApiService'

export default {
  name: 'FolderFileTrash',

  data() {
    return {
      apiService: new ApiService(),
      sizes: [10, 30, 90, 180],
      headers: [
        {
          text: '',
          align: 'center',
          value: 'isDocument',
          sortable: false,
        },
        {
          text: 'Nome',
          align: 'center',
          value: 'name',
          sortable: false,
        },
        {
          text: 'Excluído em',
          align: 'center',
          value: 'deleteAt',
          sortable: false,
        },
        {
          text: 'Ações',
          align: 'center',
          value: 'actions',
          sortable: false,
        },
      ],
      headerProps: {
        sortByText: 'Ordenar por',
      },
      filterListFolderWithDoc: {
        institutionId: null,
        name: '',
        page: 1,
        pageSize: 10,
      },
      page: 1,
      pageSize: 10,
      loading: false,
      totalPages: null,
      totalItems: null,
      totalItensOnPage: null,
      listFolderWithDoc: [],
      deleteDialog: false,
      itemToDelete: null,
    }
  },

  async created() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.loadData()
  },

  watch: {
    pageSize() {
      this.filterListFolderWithDoc.pageSize = this.pageSize
      this.filterListFolderWithDoc.page = 1
      this.getListFolderWithDoc()
    },

    page() {
      this.filterListFolderWithDoc.page = this.page
      this.getListFolderWithDoc()
    },
  },

  methods: {
    recover(item) {
      if (item.isDocument) {
        this.apiService
          .post('CommonAreaDocument/recover/' + item.id)
          .then((response) => {
            this.$toast.success('Arquivo recuperado com sucesso!')
            this.loadData()
            this.$emit('recover')
          })
      } else {
        this.apiService
          .post('CommonAreaDocumentFolder/recover/' + item.id)
          .then((response) => {
            this.$toast.success('Arquivo recuperado com sucesso!')
            this.loadData()
            this.$emit('recover')
          })
      }
    },

    formatDate(date) {
      return date ? moment(date).format('DD/MM/yyyy HH:mm') : 'Sem registro'
    },

    async loadData() {
      try {
        await Promise.all([this.getAllFolders()])
      } finally {
        this.getListFolderWithDoc()
      }
    },

    async getAllFolders(itemId) {
      const institutionId = JSON.parse(localStorage.getItem('institution')).id
      try {
        const response = await this.apiService.get(
          `CommonAreaDocumentFolder/${institutionId}`
        )
        this.allFolders = [...response.content]
        this.allFoldersWithoutRemove = [...response.content]
        if (itemId) {
          this.allFoldersWithoutOwn = [...response.content].filter(
            (folder) => folder.id !== itemId
          )
          this.allFoldersWithoutRemoveAndOwn = [...response.content].filter(
            (folder) => folder.id !== itemId
          )
        }
      } catch (error) {
        console.error(error)
      }
    },

    async getListFolderWithDoc() {
      const institutionId = JSON.parse(localStorage.getItem('institution')).id
      this.filterListFolderWithDoc.institutionId = institutionId
      this.filterListFolderWithDoc.page = this.page
      this.filterListFolderWithDoc.pageSize = this.pageSize

      try {
        const response = await this.apiService.get(
          `CommonAreaDocumentFolder/list-deleteds-with-doc`,
          this.filterListFolderWithDoc
        )
        this.panel = null
        this.listFolderWithDoc = response.content.data
        this.totalPages = response.content.pager.totalPages
        this.totalItems = response.content.pager.totalItems
        this.totalItensOnPage = response.content.data.length
      } catch (error) {
        console.error('Erro ao carregar a lista de documentos.', error)
      }
    },
    deleteItem(item) {
      this.itemToDelete = item
      this.deleteDialog = true
    },

    async confirmDelete(item) {
      if (!this.itemToDelete) return

      try {
        this.loading = true
        let endpoint = ''

        if (item.isDocument) {
          endpoint = `CommonAreaDocument/delete-permanent/${item.id}`
        } else {
          endpoint = `CommonAreaDocumentFolder/delete-permanent/${item.id}`
        }
        const response = await this.apiService.delete(endpoint)

        this.$toast.success(
          response.message || 'item excluído permanentemente com sucesso!'
        )

        this.loadData()
      } catch (error) {
        console.error('Erro ao excluir o item:', error)
        this.$toast.error('Ocorreu um erro ao tentar excluir o item')
      } finally {
        this.loading = false
        this.deleteDialog = false
        this.itemToDelete = null
        this.$emit('callSumFiles')
      }
    },
  },
}
</script>

<style scoped></style>
